import { Table, Input, Button, Space } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
// import { useHistory } from 'react-router-dom';
import {
  ArrowLeftOutlined,
  EditOutlined,
  FolderOpenOutlined,
  UserAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
import React, { useState, useEffect } from "react";
import { get, patch } from "../Libraries/Ajax/HttpService";
import back from "../assets/images/back.svg";
import edit from "../assets/images/edit.svg";
import { useNavigate } from "react-router-dom";
import { useDistrict } from "../utils/DistrictContext";
function Accountnames() {
  // let history = useHistory();
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [value, setValue] = useState([]);
  const [overridepermission, setOverridepermission] = useState(false);
  const [loading, setloading] = useState(true);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalId, setModalId] = useState("");
  const { selectedDistrict } = useDistrict();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20); // fixed 20 per page
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  var mcdata = JSON.parse(localStorage.getItem("MCData"));
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    const params = JSON.stringify({
      override_name: value.trim(),
    });
    const url = `apis/account/overide_name/edit/${modalId}`;

    patch(url, params).then((response) => {
      setConfirmLoading(true);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
      }, 2000);

      // history.go(0);
      window.location.reload();
    });
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };
  const onEditClick = (id, override) => {
    console.log(id);
    console.log(override);
    setOpen(true);
    setModalId(id);
    setModalText(override);
    setValue(override);
  };

  const columns = [
    {
      title: selectedDistrict === "FB151" ? "Account ID" : "Beacon Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Override Name",
      dataIndex: "override",
      key: "override",
    },

    {
      title: "Actions",
      dataIndex: "action",
      align: "center",
      key: "id",
      onCell: (record) => {
        return {
          onClick: (ev) => {
            onEditClick(record.id, record.override);
          },
        };
      },
      render: (_, record) => (
        <img src={edit} alt="" style={{ width: "25px" }} />
      ),
    },
  ];
  const columnss = [
    {
      title: selectedDistrict === "FB151" ? "Account ID" : "Beacon Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Override Name",
      dataIndex: "override",
      key: "override",
    },
  ];

  const onRedirection = (event) => {
    navigate(-1);
  };
  const onselectClick = () => {
    navigate("/settingsuser");
  };
  const onselectClicks = () => {
    navigate("/list");
  };
  const onselectClickaccount = () => {
    navigate("/accountnames");
  };
  const onselectMetermangement = () => {
    navigate("/metermanagement");
  };

  const onselectMeterHistory = () => {
    navigate("/meterhistory");
  };

  const onselectClickss = () => {
    navigate(-1);
  };

  // useEffect(() => {
  //   if (selectedDistrict) {
  //     getData();
  //   }
  // }, [selectedDistrict]);

  const onMouseClick = (event) => {
    if (event.target.value == "accounts") {
      navigate("/accountnames");
    } else if (event.target.value == "listing") {
      navigate("/list");
    } else if (event.target.value == "settings") {
      navigate("/settingsuser");
    }
  };
  // const getData = async () => {
  //   setloading(true);

  //   var data = JSON.parse(localStorage.getItem("MCData"));

  //   setOverridepermission(data?.mcdatas?.accounts_overide_edit);
  //   get(`apis/account/overide_name/list`).then((res) => {
  //     setloading(false);
  //     setdata(
  //       res.data.data.account_override_list.map((row) => ({
  //         name: row.account_full_name,
  //         override: row.overided_name,
  //         id: row.id,
  //       }))
  //     );
  //     console.log(data);
  //   });

  //   setloading(false);
  // };
  const getData = async (page = 1) => {
    setloading(true);
    const url = `apis/account/overide_name/list?page=${page}&page_limit=${pageSize}`;
    get(url)
      .then((res) => {
        const list = res.data.data.account_override_list || [];
        const total = res.data.data.total_records || list.length;
        const pages = res.data.data.total_pages || 1;

        setdata(
          list.map((row) => ({
            name: row.account_full_name,
            override: row.overided_name,
            id: row.id,
          }))
        );
        setTotalRecords(total);
        setTotalPages(pages);
      })
      .finally(() => setloading(false));
  };

  useEffect(() => {
    if (selectedDistrict) {
      getData(currentPage);
    }
  }, [selectedDistrict, currentPage]);

  // ---------------- Pagination Handlers ----------------
  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div>
          <div className="d-flex ">
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onselectClickss}
            />
            <div className="d-flex align-items-center">
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  <div
                    className="new-box-padding   align-self-center c-pointer"
                    style={{
                      borderBottom: "2px solid #ccc ",
                      borderRadius: "0",
                    }}
                    onClick={onselectClick}
                  >
                    {" "}
                    Settings
                  </div>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                </>
              )}
              {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  <div
                    className="new-box-padding   align-self-center c-pointer "
                    onClick={onselectClicks}
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                  >
                    {" "}
                    Users
                  </div>
                </>
              )}

              <div
                className=""
                style={{ width: "2px", height: "25px", background: "#ccc" }}
              ></div>
              <div
                className="new-box-padding text-blue   align-self-center c-pointer  "
                onClick={onselectClickaccount}
                style={{
                  borderBottom: "2px solid #1998f0",
                }}
              >
                {" "}
                Accounts
              </div>
              {/* {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                  <div
                    className="new-box-padding   align-self-center c-pointer "
                    onClick={onselectMetermangement}
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                  >
                    {" "}
                    Meter Management
                  </div>
                </>
              )} */}
              {mcdata.mcdatas.type === "U" || selectedDistrict === "FB151" ? (
                ""
              ) : (
                <>
                  {/* <div
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                  <div
                    className="new-box-padding align-self-center c-pointer"
                    onClick={onselectMetermangement}
                    style={{ borderBottom: "2px solid #ccc" }}
                  >
                    Meter Management
                  </div> */}
                </>
              )}
            </div>

            {/* {mcdata.mcdatas.type === "U" && mcdata.mcdatas.type === "U" ? (
                ""
              ) : (
                <>
                  <div
                    className=""
                    style={{ width: "2px", height: "25px", background: "#ccc" }}
                  ></div>
                  <div
                    className="new-box-padding   align-self-center c-pointer "
                    onClick={onselectMeterHistory}
                    style={{
                      borderBottom: "2px solid #ccc",
                    }}
                  >
                    {" "}
                    Meter History
                  </div>
                </>
              )} */}
            {mcdata.mcdatas.type === "U" || selectedDistrict === "FB151" ? (
              ""
            ) : (
              <>
                {/* <div
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding align-self-center c-pointer"
                  onClick={onselectMeterHistory}
                  style={{ borderBottom: "2px solid #ccc" }}
                >
                  Meter History
                </div> */}
              </>
            )}
          </div>
          <h4 class="text-blue mt-5 fw-bold mb-4 px-2">Account Listing</h4>
          {data.length > 0 && overridepermission === true ? (
            <>
              <Table
                columns={columns}
                className="styleRemove mt-4 account-table"
                dataSource={data}
                size="middle"
                pagination={false}
                loading={loading}
              />
              
              {selectedDistrict==="FB151"?<div
                className="d-flex justify-content-end align-items-center mt-3"
                style={{ paddingRight: "20px" }}
              >
                <Space>
                  <div style={{ fontSize: "14px", marginRight: "10px" }}>
                    Page <b>{page}</b> of <b>{totalPages}</b> ({totalRecords}{" "}
                    total)
                  </div>
                  <Button
                    onClick={handlePrev}
                    disabled={page <= 1}
                    type="default"
                    size="small"
                  >
                    Previous
                  </Button>
                  <Button
                    onClick={handleNext}
                    disabled={page >= totalPages}
                    type="default"
                    size="small"
                  >
                    Next
                  </Button>
                </Space>
              </div>:""}
              
            </>
          ) : (
            <>
              {" "}
              <Table
                columns={columnss}
                className="styleRemove mt-4 account-table"
                dataSource={data}
                size="middle"
                pagination={false}
                loading={loading}
                align="left"
              />{" "}
             {selectedDistrict==="FB151"?<div
                className="d-flex justify-content-end align-items-center mt-3"
                style={{ paddingRight: "20px" }}
              >
                <Space>
                  <div style={{ fontSize: "14px", marginRight: "10px" }}>
                    Page <b>{currentPage}</b> of <b>{totalPages}</b> ({totalRecords}{" "}
                    total)
                  </div>
                  <Button
                    onClick={handlePrev}
                    disabled={currentPage <= 1}
                    type="default"
                    size="small"
                  >
                    Previous
                  </Button>
                  <Button
                    onClick={handleNext}
                    disabled={currentPage >= totalPages}
                    type="default"
                    size="small"
                  >
                    Next
                  </Button>
                </Space>
              </div>:""}
              
            </>
          )}

          {open === true ? (
            <Modal
              open={open}
              onOk={handleOk}
              confirmLoading={confirmLoading}
              onCancel={handleCancel}
              centered="true"
            >
              <div className="login-form">
                <div class="forms-inputs mt-4 mb-0">
                  <span for="pwd">Override Name</span>
                  <input
                    type="text"
                    class="form-control w-100"
                    // defaultValue={modalText}
                    value={value}
                    // onChange={(e) => {
                    //   setValue(e.target.value);
                    // }}
                    onChange={(e) => setValue(e.target.value.trimStart())}
                  />
                </div>
              </div>
            </Modal>
          ) : (
            ""
          )}
        </div>
      </Main>
    </>
  );
}

export default Accountnames;
